import { Badge } from 'gcs-common/design-system/ui/badge';
import USER_TYPE from 'gcs-common/helper/userTypeHelper';
import { TICKET_INPUT_CHANNELS } from 'gcs-common/slices/tickets/ticketsConstants';
import type { Response } from 'gcs-common/types/typeHelper';
import styles from './styles.module.scss';

const TicketInfo = ({ ticket }: { ticket: Response<'/chat/ets/tickets/{ticket_id}', 'get'> }) => {
  const {
    customerOrderText,
    customerNumber,
    creatorName = '',
    creatorUserType,
    inputChannel,
    channelName,
    houseName,
  } = ticket;
  const inputChannelLabel = [
    // TODO inputChannel is marked as Optional in backend. how to act on undefined?
    TICKET_INPUT_CHANNELS[inputChannel!]?.label,
    channelName,
  ]
    .filter((x) => x)
    .join(' - ');

  return (
    <div className={styles.grid}>
      <div>Haus</div>
      <div className={styles.value}>{houseName}</div>

      <div>Kundennummer</div>
      <div className={styles.value}>{customerNumber}</div>

      <div>Kommission</div>
      <div className={styles.value}>{customerOrderText}</div>

      <div>Ersteller</div>
      <div className="flex items-center gap-2">
        <div className={styles.value}>{creatorName}</div>
        {creatorUserType === USER_TYPE.CRAFTSMAN ? <Badge variant="soft_accent">Kunde</Badge> : null}
      </div>

      <div>Eingangskanal</div>
      <div className={styles.value}>{inputChannelLabel}</div>
    </div>
  );
};

export default TicketInfo;
